<template>
    <div class="container">
        <!-- Scratch view for trying out markup and behaviour. Reachable at /test,
             not linked from the UI. Keep it free of real customer data: whatever
             is here ends up in the production bundle, which is served without
             authentication even though this route is guarded. -->
    </div>
</template>

<script>
export default {
};
</script>
